import React from 'react'
import { Link } from 'react-router-dom'

const SubscriptionExpired = () => {
  return (
    <div className="tyn-root">

      <div className="tyn-content tyn-content-page">
        <div className="tyn-main">
          <div className="tyn-section">
            <div className="container">
              <div className="tyn-text-block text-center pb-4 pb-lg-5">
                <div className="home-logo d-flex justify-content-center align-items-center">
                  <img src="/images/logo/bardo-icon-white.png" alt="" style={{ width: "76px", height: "76px" }} />
                </div>
                <h1 className="mt-3 text-white">Welcome Back to Bardo</h1>
                <h4 className="text-white mt-3">It seems your subscription has expired. We miss you!</h4>
                <p className="text-white mb-4">Reniew now to continue enjoying all the amazing features Bardo offers.</p>
              </div>


            </div>
            <div className="tyn-section-content">
              <div className="row g-4 justify-content-center">
                <div className="col-xl-3 col-lg-4 col-sm-6">
                  <div className="card h-100 border-0">
                    <div className="card-body p-4">
                      <div className="text-muted text-opacity-50 fs-7 mt-n2 fw-medium">Life Time</div>
                      <div className="h1 text-dark">$0</div>
                      <h5 className="pb-2 pt-1">Free Plan</h5>
                      <ul className="list-check fs-6 d-flex flex-column gap gap-2">
                        <li className="d-flex gap gap-2">
                          <span className="text-success">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
                              <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                            </svg>
                          </span>
                          <span>Available on low demand</span>
                        </li>
                        <li className="d-flex gap gap-2">
                          <span className="text-success">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
                              <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                            </svg>
                          </span>
                          <span>Standard response speed</span>
                        </li>
                        <li className="d-flex gap gap-2">
                          <span className="text-success">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
                              <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                            </svg>
                          </span>
                          <span>Regular model updates</span>
                        </li>
                      </ul>
                      <div className="mt-4">
                        <Link to="#" className="btn btn-primary">Reniew Plan</Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-sm-6">
                  <div className="card h-100 border-0">
                    <div className="card-body p-4">
                      <div className="text-success fs-7 mt-n2 fw-medium">Popular</div>
                      <div className="h1 text-primary">$33 <small className="fs-5">/mo</small></div>
                      <h5 className="pb-2 pt-1">Premium Plan</h5>
                      <ul className="list-check fs-6 d-flex flex-column gap gap-2">
                        <li className="d-flex gap gap-2">
                          <span className="text-success">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
                              <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                            </svg>
                          </span>
                          <span>Always Available</span>
                        </li>
                        <li className="d-flex gap gap-2">
                          <span className="text-success">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
                              <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                            </svg>
                          </span>
                          <span>Fast response speed</span>
                        </li>
                        <li className="d-flex gap gap-2">
                          <span className="text-success">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
                              <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                            </svg>
                          </span>
                          <span>Early model updates</span>
                        </li>
                      </ul>
                      <div className="mt-4">
                        <Link to="#" className="btn btn-primary">Upgrade Now</Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4">
                  <div className="card h-100 border-0">
                    <div className="card-body p-4">
                      <div className="row align-items-center">
                        <div className="col-sm-6 col-lg-12 text-sm-center d-none d-sm-block d-lg-none">
                          <div className="bg-body py-4 rounded-2">
                            <div className="tyn-media tyn-circle bg-white mb-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-buildings-fill" viewBox="0 0 16 16">
                                <path d="M15 .5a.5.5 0 0 0-.724-.447l-8 4A.5.5 0 0 0 6 4.5v3.14L.342 9.526A.5.5 0 0 0 0 10v5.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V14h1v1.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zM2 11h1v1H2zm2 0h1v1H4zm-1 2v1H2v-1zm1 0h1v1H4zm9-10v1h-1V3zM8 5h1v1H8zm1 2v1H8V7zM8 9h1v1H8zm2 0h1v1h-1zm-1 2v1H8v-1zm1 0h1v1h-1zm3-2v1h-1V9zm-1 2h1v1h-1zm-2-4h1v1h-1zm3 0v1h-1V7zm-2-2v1h-1V5zm1 0h1v1h-1z" />
                              </svg>
                            </div>
                            <div className="mt-2 pt-1 d-none d-sm-block d-lg-none">
                              <Link href="#" className="btn btn-md btn-success">Contact us</Link>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-12">
                          <div className="tyn-media tyn-circle bg-light mb-3 d-sm-none d-lg-inline-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-buildings-fill" viewBox="0 0 16 16">
                              <path d="M15 .5a.5.5 0 0 0-.724-.447l-8 4A.5.5 0 0 0 6 4.5v3.14L.342 9.526A.5.5 0 0 0 0 10v5.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V14h1v1.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zM2 11h1v1H2zm2 0h1v1H4zm-1 2v1H2v-1zm1 0h1v1H4zm9-10v1h-1V3zM8 5h1v1H8zm1 2v1H8V7zM8 9h1v1H8zm2 0h1v1h-1zm-1 2v1H8v-1zm1 0h1v1h-1zm3-2v1h-1V9zm-1 2h1v1h-1zm-2-4h1v1h-1zm3 0v1h-1V7zm-2-2v1h-1V5zm1 0h1v1h-1z" />
                            </svg>
                          </div>
                          <h5 className="pb-2 pt-1">Premium Plan</h5>
                          <ul className="list-check fs-6 d-flex flex-column gap gap-2">
                            <li className="d-flex gap gap-2">
                              <span className="text-success">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
                                  <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                                </svg>
                              </span>
                              <span>Everyting from premium</span>
                            </li>
                            <li className="d-flex gap gap-2">
                              <span className="text-success">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
                                  <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                                </svg>
                              </span>
                              <span>API Integration</span>
                            </li>
                            <li className="d-flex gap gap-2">
                              <span className="text-success">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
                                  <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                                </svg>
                              </span>
                              <span>24/7 Support assistant</span>
                            </li>
                          </ul>
                          <div className="mt-4 d-sm-none d-lg-flex">
                            <Link to="#" className="btn btn-success">Contact us</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SubscriptionExpired
